<template>
  <div class="welfare">
    <div class="bannerImg">
      <img :src="bgtop" class="video-img" loading="lazy">
      <div class="img-content">
        <h3>暖峰 让暖风一直吹 一直吹…</h3>
        <p>峰学未来多年来一直坚持做的公益事件</p>
      </div>
    </div>
    <div class="tips">
      <div class="tips-content">
        <div class="left-content">
          <!--<h3>我们的初心</h3>-->
          <p>峰学未来致力于打造一体化的人才培养及教育生态平台， 打通人才培养、升学规划及优质就业的绿色通道。
            为万千高中生和家长解决新高考选科、高中学业规划、志愿填报、大学学业规划、实习就业等各方面问题。
            我们积极主动承担社会责任，并为此开展了暖峰公益、带货助学等一系列活动。
            </p>
        </div>
        <div class="right-content">
          <!--<div class="public-price">
            <span><i>{{ allMoney }}</i>万元</span>
            <h3>历史善款总数额</h3>
          </div>-->
          <div class="public-price">
            <span><i>{{ hopeMoney }}</i>万元</span>
            <h3>历史善款总数额</h3>
          </div>
          <!--<div class="public-price">
            <span><i>{{ liveMoney }}</i>万元</span>
            <h3>直播带货佣金</h3>
          </div>-->
        </div>
      </div>
    </div>
    <div class="main-content">
      <!--暖峰行动捐助地图-->
      <public-welfare-map></public-welfare-map>
      <div class="welfare-content">
        <!--<div class="title">
          <h2>峰学未来公益活动</h2>
          <p>峰学未来通过多种途径参加公益助学活动，为每个有梦想的孩子送去希望</p>
        </div>-->
        <div class="content">
          <ul class="tab-title">
            <li :class="activeName==='action' ? 'active' : 'flex-item'" @click="handleClick('action')">
              <span>暖峰行动</span>
              <!--<p>峰学未来通过与其他公益机构合作，推出“暖峰行动”，助力有梦想的学子实现自己的人生理想。</p>-->
            </li>
            <li :class="activeName==='assistantship' ? 'active' : 'flex-item'" @click="handleClick('assistantship')">
              <span>带货助学</span>
              <!--<p>张雪峰老师在日常直播带货中售出的所有零食而产生的全部佣金都会用于捐助贫困学生的助学捐助。</p>-->
            </li>
          </ul>
          <div class="main-content" ref="wrapper" v-loading.fullscreen.lock="fullscreenLoading">
            <div class="public-list" v-if="activeName==='action'" >
              <el-timeline>
                <el-timeline-item v-for="item in updatedActionList" :key="item.uuid" :timestamp="item.start_event_time ? item.start_event_time + ' ' + item.address : ''" placement="top" type="primary" color="#0086FF">
                  <el-card>
                    <div class="left-content">
                      <p>{{ item.content }}</p>
                      <div class="contribute-info">
                        <div class="contribute-teacher">
                          <div class="header_bg">
                            <img :src="item.teacher_info.teacher_image" v-if="item.teacher_info"/>
                          </div>
                          <span v-if="item.teacher_info">{{item.teacher_info.name}}</span>
                        </div>
                        <div class="contribute-money">
                          <span v-if="item.charity_fund < 10000"><i>{{ item.charity_fund }}</i>元</span>
                          <span v-else><i>{{ (item.charity_fund / 10000).toFixed(2) }}</i>万元</span>
                        </div>
                      </div>
                    </div>
                    <div class="right-content">
                      <el-carousel trigger="click" :indicator-position="item.combinedArray.length > 1 ? 'outside' : 'none'" :arrow="item.combinedArray.length > 1 ? 'hover' : 'never'">
                        <el-carousel-item v-for="(i,index) in item.combinedArray" :key="index">
                          <el-image :src="i" :preview-src-list="item.combinedArray"></el-image>
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
            <div class="assistantship-list" v-else>
            <el-row :gutter="24">
              <el-col :span="8" :offset="3" v-for="(item, index) in assistantshipList" :key="index">
                <el-card shadow="never">
                  <router-link to="">
                    <div class="assistant-main-content"  @click="showDetail(item.cover_url)">
                      <h3 class="title">{{ convertDateFormat(item.start_event_time ? item.start_event_time: '') }}～{{ convertDateFormat(item.end_event_time ? item.end_event_time : '') }}</h3>
                      <p class="assisitship-content">
                        {{ item.content }}
                      </p>
                      <div class="view-details">
                        <span>查看详情</span>
                        <img :src="moreIcon" class="moreIcon"/>
                      </div>
                      <!--<el-image :src="item.cover_url" :preview-src-list="item.cover_url" style="opacity: 0;"></el-image>-->
                    </div>
                  </router-link>
                </el-card>
              </el-col>
            </el-row>
            <el-dialog :visible.sync="assistantshipShow">
              <div class="assistantDialog">
                <img :src="assistantshipImg" class="assistantshipImg"/>
                <img :src="chapterImg" class="chapter"/>
              </div>
              <!--<el-image :src="assistantshipImg" :preview-src-list="assistantshipImgList"></el-image>-->
            </el-dialog>

            <!--<el-image :src="assistantshipImg" :preview-src-list="assistantshipImgList" v-show="assistantshipShow"></el-image>-->
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import teamImg from '../assets/img/team.png';
import bg1 from "@/assets/img/bg1.jpg";
import moreIcon from "@/assets/img/more.png";
import chapterImg from "@/assets/img/chapter.png";
import BScroll from 'better-scroll';
import PublicWelfareMap from "@/components/PublicWelfareMap";
export default {
  name: "",
  data() {
    return {
      bgtop: bg1,
      activeName:'action',
      teamImg:teamImg,
      mold: 1,
      actionList:[],//暖峰行动列表
      assistantshipList:[],//带货助学列表
      allMoney:'',
      hopeMoney:'',
      liveMoney:'',
      updatedActionList:[],
      moreIcon:moreIcon,
      fullscreenLoading:false,
      assistantshipImg:'',
      assistantshipShow:false,
      assistantshipImgList:[],
      chapterImg:chapterImg,
      page: 0,
      size: 12,
      totalPages: 100,
      current_page:1,
      noMoreData: false,
    }
  },
  components: {
    PublicWelfareMap
  },
  /*computed:{
    noMore () {
      return this.page === this.totalRows;
    },
    disabled () {
      return this.fullscreenLoading || this.noMore
    }
  },*/
  mounted() {
    //暖峰行动
    this.loadData();
    this.$nextTick(() => {
      new BScroll(this.$refs.wrapper); // 初始化better-scroll对象

      window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
    });
    //带货助学
  },
  methods: {
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scrollBottom = scrollHeight - scrollTop - clientHeight;

      if (!this.fullscreenLoading && !this.noMoreData && scrollBottom < 10) {
        this.loadData(); // 滚动到底部时调用加载更多函数
      }
    },
    handleClick(type){
      this.activeName = type;
      this.page = 0;
      if(type === 'action') {
        this.mold = 1;
        this.actionList = [];
        this.updatedActionList = [];
      } else {
        this.mold = 2;
        this.assistantshipList = [];
      }
      this.loadData();
    },
    /**
     * @method loadDisabled 设置状态
     * @param {Null} no params
     * @return {Null} no return
     */
    setTableEnabled(){
      let timer = setTimeout(()=>{
        this.loadDisabled = false;
        clearTimeout(timer)
      },300)
    },
    loadData() {
      if (this.page >= this.totalPages) {
        this.noMoreData = true; // 已经加载完所有数据
        return;
      }
      this.fullscreenLoading = true;
      setTimeout(()=> {
        this.page++;
        this.$http({
          method: 'get',
          url: '/admin_api/v1/main_station/main/public/welfare/',
          params: {
            mold: this.mold,
            page: this.page,
            size: this.size
          },
          headers: {
            'AUTH-SYS': 'admin'
          },
        }).then(res => {
          this.fullscreenLoading = false;
          if (res.data.code === 20000) {
            this.totalPages = res.data.data.total_page;
            if (this.mold === 1) {
              this.actionList = this.actionList.concat(res.data.data.results);
              const transformedArray = this.actionList.map(item => {
                const combinedArray = [item.cover_url, ...item.image_url.map(img => img.data)];
                return {combinedArray};
              });
              this.updatedActionList = this.actionList.map((item, index) => ({
                ...item,
                ...transformedArray[index]
              }));
              window.console.log(this.updatedActionList)
            } else {
              this.assistantshipList = this.assistantshipList.concat(res.data.data.results);
            }
            this.liveMoney = parseFloat((res.data.data.help_money / 10000).toFixed(2));
            this.hopeMoney = parseFloat((res.data.data.warm_money / 10000).toFixed(2));
            this.allMoney = parseFloat((res.data.data.money / 10000).toFixed(2));
            if(this.page === this.totalPages) {
              this.noMoreData = true;
            } else {
              this.noMoreData = false;
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      })
    },
    convertDateFormat(input){
      const [year, month] = input.split('-');
      const formattedMonth = String(Number(month));
      const result = `${year}年${formattedMonth}月`;
      return result;
    },
    showDetail(url){
      this.assistantshipImg = url;
      this.assistantshipShow = true;
      this.assistantshipImgList = [url]
      //this.$router.push({name:'welfaredetail',params:{url:url}})
      /*let routeUrl = this.$router.resolve({
        path: "/welfaredetail",
        query: {url:url}
      });
      window.open(routeUrl.href, '_blank');*/
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
a{
  text-decoration: none;
}
@font-face {
  font-family: 'numberFamily';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509867414.ttf');
}
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868791.otf');
}
.welfare{
  width: 100%;
  height: 100%;
  /*background-color: #F5F7FA;*/
  position: relative;
  overflow: hidden;
  .bannerImg{
    width: 100%;
    position: relative;
    overflow: hidden;
    img{
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
    .img-content {
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translateX(-50%);
      text-align: center;

      h3 {
        font-size: 40px;
        font-family: 'SourceHanSansCNBold Microsoft YaHei';
        font-weight: bold;
        color: #FFFFFF;
        line-height: 60px;
      }

      p {
        font-size: 18px;
        font-family: 'SourceHanSansCN Microsoft YaHei';
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        line-height: 24px;
        margin-top: 30px;
      }
    }
  }
  .tips{
    width: 100%;
   /* margin: 0 auto;*/
    /*height: 224px;*/
    background: rgba(255,255,255,0.95);
    /*border-radius: 16px;*/
    border: 2px solid #FFFFFF;
    /*margin-top: -140px;*/
    z-index: 1000;
    position: relative;
    .tips-content{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      padding: 40px 40px;
      .left-content{
        width: 75%;
        h3{
          font-size: 24px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei';
          font-weight: bold;
          color: #0A0D0F;
          line-height: 36px;
        }
        p{
          /*margin-top: 20px;*/
          font-size: 18px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #0A0D0F;
          line-height: 36px;
          text-align: justify;
          letter-spacing: 1.5px;
        }
      }
      .right-content{
        display: flex;
        width: 25%;
        justify-content: flex-end;
        /*text-align: center;*/
        align-items: flex-start;
        /*margin-top: 30px;*/
        .public-price{
          margin-left: 30px;
          span{
            font-size: 16px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: 400;
            color: #0A0D0F;
            line-height: 24px;
            i{
              font-style: normal;
              font-size: 40px;
              font-family: 'numberFamily';
              color: #FF3939;
              line-height: 50px;
              font-weight: bold;
              margin-right: 10px;
            }
          }
          h3{
            font-size: 20px;
            font-family: 'SourceHanSansCNBold Microsoft YaHei';
            font-weight: bold;
            color: #0A0D0F;
            line-height: 21px;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .main-content{
    width: 100%;
    /*background: #F5F7FA;*/
    background: #FFFFFF;
    .welfare-content{
      width: 1200px;
      margin: 0 auto;
      /*padding-top: 120px;*/
      .title{
        width: 100%;
        h2{
          font-size: 40px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei';
          font-weight: bold;
          color: #0A0D0F;
          line-height: 60px;
        }
        p{
          font-size: 16px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #909295;
          line-height: 16px;
          margin-top: 30px;
        }
      }
      .content{
        width: 100%;
        margin-top: 40px;
        .tab-title {
          display: flex;
          justify-content: space-between;
          text-align: center;
          align-items: center;
          border-bottom: 1px solid rgba(219,221,224,0.5);;
          .flex-item {
            cursor: pointer;
            flex: 1;
            list-style: none;
            padding-bottom: 0;
            position: relative;
            margin: 0;
            height: 100px;
            span{
              font-size: 30px;
              font-family: 'SourceHanSansCN Microsoft YaHei';
              color: #434649;
              line-height: 100px;
              font-style: normal;
            }
          }

          .active{
            cursor: pointer;
            flex: 1;
            list-style: none;
            font-weight: bold;
            color: #0086FF;
            position: relative;
            border: none;
            margin: 0;
            border-bottom: 4px solid #0086FF;
            height: 100px;
            span{
              font-size: 30px;
              font-family: 'SourceHanSansCNBold Microsoft YaHei';
              font-weight: bold;
              line-height: 100px;
              color: #0086FF;
            }
          }
          .space{
            list-style: none;
            width: 20px;
          }
        }
        .public-list{
          margin-top: 60px;
          width: 100%;
          ::v-deep .el-timeline-item__node--primary{
            /*border-color: #0086FF;
            transition: all 0.3s linear;*/
            background-color: transparent !important;
            background: url("../assets/img/dot.png") no-repeat;
            background-size: 100% 100%;
            height: 20px;
            width: 20px;
          }
          ::v-deep .el-timeline-item__node--normal{
            left: -6px !important;
          }
          ::v-deep .el-timeline-item__tail{
            border-left: 2px dashed rgba(144,146,149,0.2);
            height: 88%;
            top: 40px;
          }
          ::v-deep .el-timeline .el-timeline-item:last-child .el-timeline-item__tail{
            display: block;
            height: 80%;
          }
          ::v-deep .el-timeline .el-timeline-item:last-child .el-timeline-item__wrapper .is-always-shadow{
            border-bottom: none;
          }
          ::v-deep .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
            box-shadow: none;
            /*border-radius: 16px;*/
            border-radius: 0;
            border: none;
            border-bottom: 1px solid rgba(219,221,224,0.5);
          }
          ::v-deep .el-card__body{
            display: flex;
            justify-content: center;
            padding:0;
          }
          ::v-deep .el-timeline-item__wrapper{
            margin-bottom: 60px;
            padding-left: 40px;
          }
          ::v-deep .el-timeline-item__timestamp.is-top{
            margin-bottom: 24px;
            font-size: 24px;
            font-family: HarmonyOS_Sans_SC;
            color: #0A0D0F;
            font-weight: bold;
            padding-top: 0;
          }
          .right-content{
            width: 362px;
            height: 100%;
            margin-left: 50px;
            border-radius: 16px;
            ::v-deep .el-carousel__container{
              height: 290px;
            }
            ::v-deep .el-carousel__indicators{
              display: none;
            }
            ::v-deep .el-carousel__arrow--right:hover{
              background-image: url('~@/assets/img/right-hover-small.png');
              background-size: cover;
            }
            ::v-deep .el-carousel__arrow--left:hover{
              background-image: url('~@/assets/img/left-hover-small.png');
              background-size: cover;
            }
            ::v-deep .el-carousel__arrow--right{
              background-image: url('~@/assets/img/right-normal.png');
              background-size: cover;
            }
            ::v-deep .el-carousel__arrow--right i{
              display: none;
            }
            ::v-deep .el-carousel__arrow--left i{
              display: none;
            }
            ::v-deep .el-carousel__arrow--left{
              background-image: url('~@/assets/img/left-normal.png');
              background-size: cover;
            }
            ::v-deep .el-image{
              img{
                border-radius: 16px;
                height: 250px;
                width: 362px;
                object-fit: cover;
              }
            }
          }
          .left-content{
            flex: 1;
            margin: 0 0 35px 0;
            position: relative;
            /*h4{
              font-size: 20px;
              font-family: 'SourceHanSansCNBold Microsoft YaHei';
              font-weight: bold;
              color: #0A0D0F;
              line-height: 30px;
            }*/
            p{
              font-size: 18px;
              font-family: 'SourceHanSansCN Microsoft YaHei';
              font-weight: 400;
              color: #0A0D0F;
              margin-top: 10px;
              line-height: 36px;
              letter-spacing: 1px;
              text-align: justify;
              display: -webkit-box; /* 必须设置display为-webkit-box */
              overflow: hidden; /* 隐藏超出容器范围的内容 */
              text-overflow: ellipsis; /* 当内容被修剪时显示省略号 */
              -webkit-line-clamp: 4; /* 只显示前三行 */
              -webkit-box-orient: vertical; /* 垂直布局 */
              max-height: 144px;
            }
            .contribute-info{
              display: flex;
              align-items: center;
              position: absolute;
              width: 100%;
              left: 0;
              bottom: 0;
              .contribute-teacher{
                display: flex;
                align-items: center;
                flex: 1;
                .header_bg{
                  width: 36px;
                  height: 36px;
                  border-radius: 6px;
                  background-image: url("../assets/img/headerImg.png");
                  background-size: contain;
                }
                img{
                  width: 36px;
                  height: 36px;
                  border-radius: 6px;
                }
                span{
                  margin-left: 8px;
                  font-weight: 400;
                  font-size: 18px;
                  color: #0A0D0F;
                  line-height: 27px;
                  font-family: 'SourceHanSansCN Microsoft YaHei';
                }
              }
              .contribute-money{
                span{
                  font-size: 16px;
                  font-family: 'SourceHanSansCN Microsoft YaHei';
                  font-weight: 400;
                  color: #0A0D0F;
                  line-height: 24px;
                  i{
                    font-style: normal;
                    font-size: 30px;
                    font-family: 'numberFamily';
                    color: #FF3939;
                    font-weight: bold;
                    line-height: 34px;
                    margin-right: 5px;
                  }
                }
              }
            }
          }
        }
        .assistantship-list{
          margin-top: 60px;
          width: 100%;
          .el-col-8{
            margin-bottom: 30px;
            text-decoration: none;
            .el-card{
              border-radius: 16px;
              background-image: url('../assets/img/loveBg.png');
              background-size: cover;
              width: 100%;
              height: 100%;
              border: none;
              .assistant-main-content{
                padding: 12px 16px 10px 10px;
              }
              .title{
                font-size: 20px;
                font-family: 'SourceHanSansCNBold Microsoft YaHei';
                font-weight: bold;
                color: #0A2238;
                line-height: 30px;
              }
              .assisitship-content{
                margin-top: 12px;
                font-size: 16px;
                font-family: 'SourceHanSansCN Microsoft YaHei';
                font-weight: 400;
                color: #536177;
                line-height: 30px;
                letter-spacing: 1px;
                /*padding-bottom: 60px;*/
                text-align: justify;
                display: -webkit-box; /* 必须设置display为-webkit-box */
                overflow: hidden; /* 隐藏超出容器范围的内容 */
                text-overflow: ellipsis; /* 当内容被修剪时显示省略号 */
                -webkit-line-clamp: 3; /* 只显示前三行 */
                -webkit-box-orient: vertical; /* 垂直布局 */
                height: 86px;
              }
              .view-details{
                width: 100%;
                /*text-align: right;*/
                margin-top: 20px;
                display: flex;
                justify-content: flex-end;
                height: 18px;
                span{
                  font-size: 14px;
                  font-family: 'SourceHanSansCN Microsoft YaHei';
                  font-weight: 400;
                  color: #0A2238;
                  line-height: 18px;
                }
                .moreIcon{
                  width: 12px;
                  height: 12px;
                  margin-left: 5px;
                  margin-top: 2.7px;
                }
              }
              /*.view-details:after{
                content: ">";
                font-size: 12px;
                color: #0A2238;
                margin-left: 5px;
              }*/
            }
          }
          .assistantDialog{
            width: 100%;
            height: 100%;
            position: relative;
            .assistantshipImg{
              /*width: 800px;*/
              width: 100%;
              height: 100%;
              border-radius: 16px;
            }
            .chapter{
              position: absolute;
              right: 25px;
              bottom: 35px;
              width: 150px;
              height: 150px;
              transform: rotate(-15deg);
            }
          }
          ::v-deep .el-dialog{
            width: 30%;
            border-radius: 16px;
            background-color: transparent;
            box-shadow: none;
          }
          ::v-deep .el-dialog__header{
            padding: 0;
          }
          ::v-deep .el-dialog__body{
            padding: 0;
          }
        }
      }
    }
  }
}
</style>